const base = '/images';

export const images = {
  branding: {
    logo: `${base}/branding/AOK_LandscapeLogo_PaleTransparentBackground.png`,
    favicon: `${base}/branding/Favicon.png`,
  },
  home: {
    background: `${base}/home/AOK_Background.jpg`,
    homeImage: `${base}/home/AOK_Home_Image.jpg`,
    publicSpeaking: `${base}/home/AOK_Public_Speaking.jpg`,
    digitalMarketingCarousel: `${base}/home/IMG_0376.JPG`,
    webDesign: `${base}/home/AOK_Digital_Marketing.jpg`,
    contact: `${base}/home/IMG_0506.JPG`,
  },
  values: {
    hero: `${base}/values/AOK_What_We_Value.jpg`,
  },
  team: {
    alison: `${base}/team/Alison-Headshot.jpg`,
    leah: `${base}/team/Leah-Headshot.png`,
    eoin: `${base}/team/Eoin-Headshot.jpg`,
    daniel: `${base}/team/Daniel-Headshot.jpg`,
  },
  services: {
    publicSpeaking: `${base}/services/IMG_0591.JPG`,
    webDesignHero: `${base}/services/AOK_Web_Design_Overview.jpg`,
    webDesignSpeaking: `${base}/services/AOK_Web_Design_Development.jpg`,
    webDesignGraphic: `${base}/services/AOK_Web_Design_Workspace.jpg`,
    webDesignShowcase: `${base}/services/IMG_8675.JPG`,
    marketing1: `${base}/services/Image-1.jpg`,
    marketing2: `${base}/services/Image-2.jpg`,
    marketing3: `${base}/services/Image-3.jpg`,
    marketingHero: `${base}/services/IMG_0355.JPG`,
    vision: `${base}/services/AOK_Vision.jpg`,
  },
  blog: {
    fiveSigns: `${base}/blog/5Signs.jpg`,
    musicFestival: `${base}/blog/MusicFestival.jpg`,
    productivity: `${base}/blog/Productivity.png`,
    barbie: `${base}/blog/Barbie.png`,
    metaAi: `${base}/blog/MetaAI.png`,
    presentation: `${base}/blog/AOK_Presentation.jpg`,
    hashtags: `${base}/blog/Hashtags.jpg`,
    networking: `${base}/blog/AOK_Networking.jpeg`,
    linkedin: `${base}/blog/Linkedin.png`,
    digitalFrontier: `${base}/blog/DigitalFrontier.jpg`,
  },
};

export const ALL_IMAGES = [
  images.branding.logo,
  images.home.background,
  images.home.homeImage,
  images.home.publicSpeaking,
  images.home.digitalMarketingCarousel,
  images.home.webDesign,
  images.home.contact,
  images.values.hero,
  images.team.alison,
  images.team.leah,
  images.team.eoin,
  images.team.daniel,
  images.services.publicSpeaking,
  images.services.webDesignHero,
  images.services.webDesignSpeaking,
  images.services.webDesignGraphic,
  images.services.webDesignShowcase,
  images.services.marketing1,
  images.services.marketing2,
  images.services.marketing3,
  images.services.marketingHero,
  images.services.vision,
  images.blog.fiveSigns,
  images.blog.musicFestival,
  images.blog.productivity,
  images.blog.barbie,
  images.blog.metaAi,
  images.blog.presentation,
  images.blog.hashtags,
  images.blog.networking,
  images.blog.linkedin,
  images.blog.digitalFrontier,
];
